module.exports = __webpack_public_path__ + "img/lead-07z.4dc5f119.png";